module.exports = {
	"articleTitle1": "This fall, Stockwell Hall will return as coed dorm",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Stockwell Hall",
	"bathroomrating": [
		{
			"rating": 5,
			"bathroom": "All Bathrooms"
		}
	],
	"articleLink2": "https://www.michigandaily.com/content/stockwell-renovation-blends-old-and-new",
	"articleSnippet1": "Nov 3, 2008 ... A female-only dormitory since its opening in 1940, Stockwell Hall will house both \nmale and female students when it reopens next fall, signifying ...",
	"articleSnippet2": "Sep 9, 2009 ... The brand new Stockwell Residence Hall boasts amenities one would be hard-\npressed to find in other residence halls. But for LSA sophomore ...",
	"articleLink1": "https://www.michigandaily.com/content/2008-11-04/fall-stockwell-hall-will-return-coed-dorm",
	"articleTitle2": "Stockwell renovation blends old and new",
	"address": "324 Observatory St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.27865,
		"lng": -83.731388
	},
	"tips": [
		{
			"text": "A great place for sophomores, small community, pretty quiet because everyone \"knows the drill,\" so it's a good place for social and studying environments",
			"person": "Anon"
		},
		{
			"text": "If you don't have your housing figured out for sophomore year, this dorm is beautiful and quiet. It also has a huge study room upstairs that looks like a living room in a mansion that always has open seats and is pretty quiet if you can get someone to swipe you in.",
			"person": "Amelia Cacchione"
		}
	],
	"totalMisc": 1,
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/stockwell.json
// module id = 982
// module chunks = 0